import {MaterialType} from '@domain/materials'

const LAST_SELECTED_MATERIAL_KEY = 'lastSelectedMaterial'

type LastSelectedMaterial = {
  plantCode: string
  materialType: string
  materialId?: string
}

const getStorage = (): LastSelectedMaterial | null => {
  try {
    const stored = localStorage.getItem(LAST_SELECTED_MATERIAL_KEY)
    return stored ? JSON.parse(stored) : null
  } catch {
    return null
  }
}

export const getLastSelectedMaterialType = (plantCode: string): MaterialType | null => {
  const storage = getStorage()
  if (!storage || storage.plantCode !== plantCode) return null

  return (storage.materialType as MaterialType) || null
}

export const getLastSelectedMaterialId = (
  plantCode: string,
  materialType: string
): string | null => {
  const storage = getStorage()
  if (!storage || storage.plantCode !== plantCode || storage.materialType !== materialType) {
    return null
  }

  return storage.materialId || null
}

export const saveLastSelectedMaterial = (
  plantCode: string,
  materialType: string,
  materialId: string
): void => {
  try {
    const data: LastSelectedMaterial = {
      plantCode,
      materialType,
      materialId
    }
    localStorage.setItem(LAST_SELECTED_MATERIAL_KEY, JSON.stringify(data))
  } catch {
    //
  }
}

export const saveLastSelectedMaterialType = (plantCode: string, materialType: string): void => {
  try {
    const data: LastSelectedMaterial = {
      plantCode,
      materialType
    }
    localStorage.setItem(LAST_SELECTED_MATERIAL_KEY, JSON.stringify(data))
  } catch {
    //
  }
}
